import { getApp, getApps, initializeApp } from "firebase/app";
import {
  initializeAppCheck,
  ReCaptchaEnterpriseProvider,
} from "firebase/app-check";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyDozbv6pjI1qHIurIo37JQzB8CUyJHTnmw",
  authDomain: "recovery-compass-nh.firebaseapp.com",
  projectId: "recovery-compass-nh",
  storageBucket: "recovery-compass-nh.firebasestorage.app",
  messagingSenderId: "919341972778",
  appId: "1:919341972778:web:937f578e59145c3a073253",
  measurementId: "G-EVMGM70PMH",
};

export const firebaseApp = getApps().length ? getApp() : initializeApp(firebaseConfig);

if (
  typeof window !== "undefined" &&
  !["localhost", "127.0.0.1"].includes(window.location.hostname)
) {
  initializeAppCheck(firebaseApp, {
    provider: new ReCaptchaEnterpriseProvider(
      "6Ld8M9otAAAAAEa5ddNM22K4HaUUXfliuTCLj7KP"
    ),
    isTokenAutoRefreshEnabled: true,
  });
}

export const auth = getAuth(firebaseApp);
export const db = getFirestore(firebaseApp);
export const storage = getStorage(firebaseApp);
